import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ShieldCheck } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "/clarity-zones-logo.png";

export default function AdminLogin() {
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      loginAdmin(res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Clarity Zones" className="h-10 w-auto mx-auto mb-6 brightness-0 invert" />
          <div className="flex items-center justify-center gap-2 mb-2">
            <ShieldCheck className="w-5 h-5 text-slate-400" />
            <span className="text-sm font-mono text-slate-400 tracking-widest">ADMIN</span>
          </div>
        </div>

        <form onSubmit={handleLogin} className="bg-slate-800 border border-slate-700 rounded-lg p-8 space-y-5">
          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-300" htmlFor="admin-user">Benutzername</label>
            <Input
              id="admin-user"
              data-testid="admin-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="h-11 bg-slate-900 border-slate-600 text-white focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-sm placeholder:text-slate-500"
              autoComplete="off"
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-300" htmlFor="admin-pass">Passwort</label>
            <Input
              id="admin-pass"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-11 bg-slate-900 border-slate-600 text-white focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded-sm placeholder:text-slate-500"
              autoComplete="off"
            />
          </div>

          {error && (
            <div className="p-3 bg-red-900/30 border border-red-800 rounded-lg text-sm text-red-300" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            data-testid="admin-login-button"
            disabled={loading}
            className="w-full bg-sky-600 text-white hover:bg-sky-500 rounded-sm h-11 font-bold text-sm"
          >
            {loading ? "..." : "Anmelden"}
          </Button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="block mx-auto mt-6 text-xs text-slate-500 hover:text-slate-300 transition-colors"
          data-testid="back-to-login"
        >
          Zurück zum Teilnehmer-Login
        </button>
      </div>
    </div>
  );
}
